import React from 'react';
interface SparkLogoProps {
  size?: number;
}
export function SparkLogo({
  size = 30
}: SparkLogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/cVn5VmpqF68Fq11x8iUWmC/ChatGPT_Image_Aug_2,_2025_at_11_58_50_PM.png" alt="SparkHR" width={size} height={size} className="object-contain" style={{
    width: size,
    height: size
  }} data-id="element-364" />;
}